import { render, staticRenderFns } from "./PlanPartnersInfo.vue?vue&type=template&id=09d2cd58&scoped=true&"
import script from "./PlanPartnersInfo.vue?vue&type=script&lang=js&"
export * from "./PlanPartnersInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlanPartnersInfo.vue?vue&type=style&index=0&id=09d2cd58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d2cd58",
  null
  
)

export default component.exports